<template>
  <div>
    <v-dialog
      v-model="showDialog"
      width="400"
      persistent
    >
      <v-card>
        <v-card-text class="pa-4">
          <div class="text-center mt-2">
            <img
              src="../images/巧巧郎賬號與1688綁定.svg"
              height="50"
            >
          </div>
          <div class="text-center mt-2">
            首次管理包裹需完成簡訊驗證
          </div>
          <SignUp
            hideInvite
            hideTitle
            isBindAli
            @close="close"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SignUp from '../../components/SignUp.vue'
export default {
  components: {
    SignUp,
  },
  data () {
    return {
      showDialog: false,
    }
  },
  mounted () {
    if (this.$route.query.aliBind) {
      this.showDialog = true
    }
  },
  methods: {
    open () {
      this.showDialog = true
    },
    close () {
      this.showDialog = false
    },
  },
}
</script>
